import { useNavigate } from "react-router-dom";
import { ShieldAlert, Home, LogIn } from "lucide-react";
import { AuthLayout } from "@/components/ui/auth-layout";
import { Panel } from "@/components/ui/panel";
import { Heading } from "@/components/ui/heading";
import { Text, Muted } from "@/components/ui/text";
import { Button } from "@/components/ui/button";

export default function UnauthorizedRoute() {
  const navigate = useNavigate();

  return (
    <AuthLayout>
      <Panel padding="lg" className="space-y-6">
        {/* Icon */}
        <div className="flex justify-center">
          <div className="rounded-full bg-red-100 p-3">
            <ShieldAlert className="h-10 w-10 text-red-600" />
          </div>
        </div>

        {/* Content */}
        <div className="text-center space-y-2">
          <Heading size="lg">401 - Unauthorized</Heading>
          <Muted>Your session has expired or you are not authenticated.</Muted>
        </div>

        <Text className="text-center">Please log in again to access this resource.</Text>

        {/* Actions */}
        <div className="flex flex-col gap-2">
          <Button variant="primary" className="w-full" onClick={() => navigate("/login")}>
            <LogIn className="mr-2 h-4 w-4" />
            Log In
          </Button>
          <Button variant="outline" className="w-full" onClick={() => navigate("/")}>
            <Home className="mr-2 h-4 w-4" />
            Go to Home
          </Button>
        </div>
      </Panel>
    </AuthLayout>
  );
}
